import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddDeviceToLinkableObject = _resolveComponent("AddDeviceToLinkableObject")

  return (_openBlock(), _createBlock(_component_AddDeviceToLinkableObject, {
    currentDevices: _ctx.currentDevicesCommands,
    assignableDevices: _ctx.devicesCommands,
    linkableObject: _ctx.commandGroup,
    addToastMessage: _ctx.$t('general.commandAdded'),
    ruleServiceType: _ctx.SlotRuleServiceType.COMMANDS_AND_GROUPS
  }, null, 8, ["currentDevices", "assignableDevices", "linkableObject", "addToastMessage", "ruleServiceType"]))
}